import React from 'react';
import "./sidebar.css";
import {useKeycloak} from "@react-keycloak/web";


const Sidebar = () => {

    const { keycloak } = useKeycloak();
    console.log(window.location.href);

    let roleCoPCheck;
    let roleCoPCheckReport;
    let roleCheck;
    let roleCheckReport;
    console.log(keycloak.tokenParsed.realm_access.roles);
    if(keycloak.tokenParsed != null) {
        roleCoPCheck = keycloak.tokenParsed.realm_access.roles.filter(f => f.match("CoPCheck"));
        roleCheck = roleCoPCheck[0] === "CoPCheck";
    }

    if(keycloak.tokenParsed != null) {
        roleCoPCheckReport = keycloak.tokenParsed.realm_access.roles.filter(f => f.match("CoPReport"));
        roleCheckReport = roleCoPCheckReport[0] === "CoPReport";
    }

    const roleCheckLocked = false;

    return (
        <nav id="sidebarMenu" className="sidebar">
            <div className="position-sticky">
                <div className="list-group list-group-flush">
                    {/*<a*/}
                    {/*    href="#"*/}
                    {/*    tabIndex="1"*/}
                    {/*    className="test nav-link list-group-item list-group-item-action ripple "*/}
                    {/*    aria-current="true"*/}
                    {/*>*/}
                    {/*    <i className="fas fa-tachometer-alt fa-fw symbol-pic"/><span>Dashboard</span>*/}
                    {/*</a>*/}
                    { roleCheck ?
                        <a href="/"
                           className="nav-link list-group-item list-group-item-action ripple ">
                            <i className="fas fa-chart-area fa-fw symbol-pic"/><span id="manualCoPCheckText" className="menu-text">Manual CoP Check</span>
                        </a> : null
                    }
                    { roleCheckLocked ?
                        <a href="AuditQuery" className="nav-link list-group-item list-group-item-action ripple ">
                            <i className="fas fa-lock fa-fw symbol-pic"/><span>Audit Query</span>
                        </a> : null
                    }
                    { roleCheckLocked ?
                        <a href="#3" className="nav-link list-group-item list-group-item-action ripple ">
                            <i className="fas fa-chart-line fa-fw symbol-pic"/><span>System Health</span>
                        </a> : null
                    }
                    { roleCheckLocked ?
                        <a href="#4" className="nav-link list-group-item list-group-item-action ripple ">
                            <i className="fas fa-chart-pie fa-fw symbol-pic"/><span>System Parameters</span>
                        </a> : null
                    }
                    { roleCheckReport ?
                        <a href="Reports" className="nav-link list-group-item list-group-item-action ripple">
                            <i className="fas fa-chart-bar fa-fw symbol-pic"/><span id="reportsText" className="menu-text">Reports</span>
                        </a> : null
                    }
                </div>
            </div>
        </nav>
    );
};

export default Sidebar;
